export const pageTypes = {
  ABOUT_PAGE_COLLECTION_TYPE: 'marketing-about-page',
  AI_IMAGE_GENERATOR_COLLECTION_TYPE: 'ai-image-generator-micro-app',
  AI_VECTOR_GENERATOR_COLLECTION_TYPE: 'ai-vector-generator-micro-app',
  FEATURES_CHILD_COLLECTION_TYPE: 'marketing-child-feature-pages',
  FEATURES_PARENT_COLLECTION_TYPE: 'marketing-parent-feature-page',
  MONOTYPE_PAGE_COLLECTION_TYPE: 'marketing-monotype-partnership',
  SOLUTIONS_CHILD_COLLECTION_TYPE: 'marketing-child-solution-pages',
  SOLUTIONS_PARENT_COLLECTION_TYPE: 'marketing-parent-solution-page',
  VECTORIZER_COLLECTION_TYPE: 'vectorizer-micro-app',
  CAREERS_PAGE_COLLECTION_TYPE: 'marketing-careers-page',
  COMMUNITY_PAGE_COLLECTION_TYPE: 'marketing-community-page',
  AI_USE_CASE_GENERATOR_PAGE_COLLECTION_TYPE: 'ai-use-case-generator-pages',
  BACKGROUND_REMOVER_MICRO_APP: 'background-remover-micro-app',
} as const;

export const pageTypesOldStructure = {
  AI_WRITING_CHILD_PAGE_COLLECTION_TYPE: 'ai-writing-child-pages',
  AI_WRITING_PARENT_PAGE_COLLECTION_TYPE: 'ai-writing-parent-pages',
  CREATE_LIBRARY_PAGE_COLLECTION_TYPE: 'create-library-page',
  CREATE_SUB_USE_CASE_PAGE_COLLECTION_TYPE: 'create-sub-use-case-pages',
  CREATE_USE_CASE_PAGE_COLLECTION_TYPE: 'create-use-case-pages',
  MOCKUP_CHILD_PAGE_COLLECTION_TYPE: 'mockup-child-pages',
  MOCKUP_PARENT_PAGE_COLLECTION_TYPE: 'mockup-parent-pages',
  TEMPLATE_SUB_USE_CASE_PAGE_COLLECTION_TYPE: 'templates-sub-use-case-pages',
  TEMPLATE_USE_CASE_PAGE_COLLECTION_TYPE: 'templates-use-case-pages',
  TOOLS_LIBRARY_PAGE_COLLECTION_TYPE: 'tools-library-page',
} as const;

export const otherStrapiCollections = {
  // not a real page type, but need to be also revalidated
  CATEGORY_COLLECTION_TYPE: 'categories',
  SUB_USE_CASE_COLLECTION_TYPE: 'sub-use-cases',
  USE_CASE_COLLECTION_TYPE: 'use-cases',
} as const;

export type PageCollectionTypes = (typeof pageTypes)[keyof typeof pageTypes];
export type OldPagesCollectionTypes =
  (typeof pageTypesOldStructure)[keyof typeof pageTypesOldStructure];
export type OtherStrapiCollectionsTypes =
  (typeof otherStrapiCollections)[keyof typeof otherStrapiCollections];
export type AllStrapiCollectionTypes =
  | PageCollectionTypes
  | OldPagesCollectionTypes
  | OtherStrapiCollectionsTypes;
